<section class="security-panel">
  <div class="security-panel__content">
    <div class="security-panel__title">
      <h2 *ngIf="data.title" #titleEl>{{ data.title.value }}</h2>
      <h3 *ngIf="data.subtitle" #subtitleEl>{{ data.subtitle.value }}</h3>
    </div>

    <div *ngIf="data?.items?.value" class="security-panel__items" #itemWrapperEl>
      <app-security-panel-item *ngFor="let item of data.items.value" [item]="item"></app-security-panel-item>
    </div>
  </div>
</section>
